module.exports = __webpack_public_path__ + "static/1732685807992/media/i-icon.c02ca8e8.svg";